import React, { useState } from "react";
import ShootingStar from "../../components/3d-components/shooting-star";
import styleSheet from "./style.module.scss";
import SySolarSystem from "../../../../shared/components/sy-solar-system";
import { planetData } from "../config";
import { useNavigate } from "react-router-dom";

type Props = {};

const OrbitHomeScreen = (props: Props) => {
  const navigate = useNavigate();

  const onHandleClick = (data: any) => {
    navigate(`/screen/${data.id}`);
  };

  return (
    <>
      <div className="row ">
        {planetData.map((orbit: any) => (
          <div
            className={`${styleSheet.home}  col-lg-2  col-md-4 col-sm-4 ms-4 mt-5`}
            key={orbit.id}
            onClick={() => {
              onHandleClick(orbit);
            }}
          >
            <h4 className="text-white mt-4 ms-5">{orbit.title}</h4>

            <SySolarSystem layout={orbit.layout} />
          </div>
        ))}
      </div>
    </>
  );
};

export default OrbitHomeScreen;
